import { useState, useEffect, useRef } from 'react';

const C = {
  bg:"#0c1e09", surface:"#111f0d", gold:"#d9c20d", text:"#e8f0e6",
  textDim:"#4a6646", textMid:"#8faa8a", greenBorder:"#3a7029", greenLight:"#1f4516",
  teal:"#34d399", red:"#ef4444", blue:"#60a5fa", purple:"#a78bfa",
};

const FIELD_POS = {
  P:   { x:170, y:162 }, C:   { x:170, y:262 },
  "1B":{ x:242, y:192 }, "2B":{ x:212, y:122 },
  SS:  { x:128, y:122 }, "3B":{ x: 98, y:192 },
  LF:  { x: 62, y: 60 }, CF:  { x:170, y: 28 }, RF:  { x:278, y: 60 },
};
const SLOT_Q = {
  P:["P"], C:["C"], "1B":["1B"], "2B":["2B","MIF"],
  SS:["SS","MIF"], "3B":["3B"], LF:["LF","OF"], CF:["CF","OF"], RF:["RF","OF"],
};
const posCol=(p)=>{
  if(p==="P")return C.gold;if(p==="C")return C.blue;
  if(["1B","2B","3B","SS","MIF"].includes(p))return C.teal;
  if(["LF","CF","RF","OF"].includes(p))return C.purple;return C.textMid;
};
const buildMap=(players)=>{
  const m={};
  for(const[slot,q]of Object.entries(SLOT_Q)){
    m[slot]=players.filter(p=>(p.positions||[]).some(pos=>q.includes(pos))).sort((a,b)=>(parseInt(a.jersey)||999)-(parseInt(b.jersey)||999));
  }
  return m;
};
const stackOff=(n)=>{
  if(n===1)return[{dx:0,dy:0}];
  if(n===2)return[{dx:-14,dy:0},{dx:14,dy:0}];
  if(n===3)return[{dx:-16,dy:5},{dx:0,dy:-11},{dx:16,dy:5}];
  const base=[{dx:-15,dy:-9},{dx:15,dy:-9},{dx:-15,dy:11},{dx:15,dy:11}];
  if(n<=4)return base;
  const extras=Array.from({length:n-4},(_,i)=>{const a=(i/(n-4))*Math.PI*2-Math.PI/2;return{dx:Math.round(Math.cos(a)*22),dy:Math.round(Math.sin(a)*20)};});
  return[...base,...extras];
};

function FacilityDiamond({players,highlightId=null,scale=1}){
  const map=buildMap(players);
  const W=340,H=300;
  const home={x:170,y:278},first={x:248,y:200},second={x:170,y:122},third={x:92,y:200};
  return(
    <svg width={Math.round(W*scale)} height={Math.round(H*scale)} viewBox={`0 0 ${W} ${H}`} style={{display:"block"}}>
      <rect x={0} y={0} width={W} height={H} fill="#0a1c07"/>
      <path d={`M ${home.x} ${home.y} L ${third.x-30} ${third.y-30} Q 10 20, ${W/2} 8 Q ${W-10} 20, ${first.x+30} ${first.y-30} Z`} fill="#122b0d" stroke={C.greenBorder} strokeWidth={0.5}/>
      <path d={`M ${home.x} ${home.y} L ${first.x} ${first.y} L ${second.x} ${second.y} L ${third.x} ${third.y} Z`} fill="#1e3a08" stroke={C.greenBorder} strokeWidth={1}/>
      <circle cx={170} cy={200} r={50} fill="#152e0a"/>
      <circle cx={170} cy={200} r={8} fill="#1e3a08" stroke={C.greenBorder} strokeWidth={0.5}/>
      <circle cx={170} cy={200} r={3} fill={C.greenBorder} opacity={0.5}/>
      <line x1={home.x} y1={home.y} x2={first.x} y2={first.y} stroke={C.greenBorder} strokeWidth={0.75} opacity={0.6}/>
      <line x1={first.x} y1={first.y} x2={second.x} y2={second.y} stroke={C.greenBorder} strokeWidth={0.75} opacity={0.6}/>
      <line x1={second.x} y1={second.y} x2={third.x} y2={third.y} stroke={C.greenBorder} strokeWidth={0.75} opacity={0.6}/>
      <line x1={third.x} y1={third.y} x2={home.x} y2={home.y} stroke={C.greenBorder} strokeWidth={0.75} opacity={0.6}/>
      <line x1={home.x} y1={home.y} x2={20} y2={10} stroke={C.greenBorder} strokeWidth={0.5} opacity={0.35} strokeDasharray="3,4"/>
      <line x1={home.x} y1={home.y} x2={320} y2={10} stroke={C.greenBorder} strokeWidth={0.5} opacity={0.35} strokeDasharray="3,4"/>
      {[first,second,third].map((b,i)=><rect key={i} x={b.x-5} y={b.y-5} width={10} height={10} fill={C.surface} stroke={C.greenBorder} strokeWidth={1} transform={`rotate(45,${b.x},${b.y})`}/>)}
      <polygon points={`${home.x},${home.y+6} ${home.x+5},${home.y+2} ${home.x+4},${home.y-5} ${home.x-4},${home.y-5} ${home.x-5},${home.y+2}`} fill={C.surface} stroke={C.greenBorder} strokeWidth={1}/>
      {Object.entries(FIELD_POS).map(([posKey,pos])=>{
        const ps=map[posKey]||[];
        const col=posCol(posKey);
        const offs=stackOff(ps.length);
        const haloR=ps.length<=2?26:ps.length<=4?36:48;
        const hasHL=highlightId&&ps.some(p=>String(p.id||p.name)===String(highlightId));
        const op=(highlightId&&!hasHL)?0.25:1;
        return(
          <g key={posKey} style={{opacity:op,transition:"opacity 0.4s"}}>
            {ps.length===0&&<>
              <circle cx={pos.x} cy={pos.y} r={18} fill="#0a1c07" stroke={C.greenBorder} strokeWidth={0.75} opacity={0.5}/>
              <text x={pos.x} y={pos.y+1} textAnchor="middle" dominantBaseline="middle" style={{fontSize:"10px",fontFamily:"monospace",fill:C.textDim,opacity:0.5}}>{posKey}</text>
            </>}
            {ps.length>0&&<>
              <circle cx={pos.x} cy={pos.y} r={haloR} fill={hasHL?C.gold+"18":col+"12"} stroke={hasHL?C.gold+"99":col+"30"} strokeWidth={hasHL?2.5:1}/>
              <text x={pos.x} y={pos.y-haloR-5} textAnchor="middle" style={{fontSize:"9px",fontFamily:"monospace",fill:col,letterSpacing:"1.5px",opacity:0.9}}>{posKey}</text>
              {ps.map((player,i)=>{
                const off=offs[i],cx=pos.x+off.dx,cy=pos.y+off.dy;
                const isHL=String(player.id||player.name)===String(highlightId);
                return(
                  <g key={player.name+i}>
                    {isHL&&<circle cx={cx} cy={cy} r={24} fill={C.gold+"20"} stroke={C.gold+"66"} strokeWidth={2}/>}
                    <circle cx={cx} cy={cy} r={18} fill={isHL?C.gold+"33":C.surface} stroke={isHL?C.gold:col} strokeWidth={isHL?2.5:1.5}/>
                    <text x={cx} y={cy+1} textAnchor="middle" dominantBaseline="middle" style={{fontSize:"13px",fontFamily:"monospace",fontWeight:700,fill:isHL?C.gold:col}}>{player.jersey||"#"}</text>
                  </g>
                );
              })}
            </>}
          </g>
        );
      })}
    </svg>
  );
}

function PlayerSpotlight({player,animKey=0,animVars={dx:'0px',dy:'0px'},showAnim=false}){
  if(!player)return null;
  const isPitcher=(player.positions||[]).includes("P");
  const isPureP=isPitcher&&(player.positions||[]).length===1;
  const isPos=(player.positions||[]).some(p=>["C","1B","2B","3B","SS","MIF","LF","CF","RF","OF"].includes(p));
  const st=player.stats||null;
  const ops=(st?.ops&&!isPureP)?st.ops:null;
  const era=(st?.era&&isPitcher)?st.era:null;
  const hasStats=!!(ops||era);
  return(
    <div key={animKey} style={{
      '--dx':animVars.dx,'--dy':animVars.dy,
      animation:showAnim?'facCardAnim 0.6s ease-in-out':'none',
      background:C.surface,border:`2px solid ${C.gold}88`,borderRadius:"14px",
      padding:"32px 36px",minWidth:"340px",maxWidth:"420px",textAlign:"center",
    }}>
      <div style={{width:"280px",height:"280px",borderRadius:"10px",background:C.greenLight,border:`3px solid ${C.gold}55`,margin:"0 auto 20px",display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",flexShrink:0,position:"relative"}}>
        {player.photoUrl&&<img src={player.photoUrl} style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"center 20%",display:"block"}} alt={player.name} onError={e=>{e.target.style.display="none";}}/>}
        <span style={{fontFamily:"'Bebas Neue',serif",fontSize:"80px",color:C.gold,position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",zIndex:player.photoUrl?-1:0}}>W</span>
      </div>
      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"96px",color:C.gold,lineHeight:1}}>#{player.jersey||"—"}</div>
      <div style={{fontSize:"36px",color:C.text,fontWeight:700,marginTop:"8px",marginBottom:"12px",lineHeight:1.15}}>{player.name}</div>
      {player.ageGroup&&<div style={{fontSize:"14px",color:C.textDim,letterSpacing:"3px",marginBottom:"10px"}}>{player.ageGroup}</div>}
      <div style={{display:"flex",gap:"8px",flexWrap:"wrap",justifyContent:"center",marginBottom:"12px"}}>
        {(player.positions||[]).map(pos=>(
          <span key={pos} style={{background:posCol(pos)+"22",color:posCol(pos),border:`1px solid ${posCol(pos)}44`,padding:"6px 16px",borderRadius:"4px",fontSize:"18px",fontWeight:600}}>{pos}</span>
        ))}
      </div>
      {(player.gradYear||player.bats||player.throws)&&<div style={{fontSize:"14px",color:C.textDim,letterSpacing:"1px",marginBottom:"12px"}}>{[player.gradYear?`CLASS OF '${String(player.gradYear).slice(-2)}`:"",(player.bats&&player.throws)?`B/T: ${player.bats}/${player.throws}`:""].filter(Boolean).join(" · ")}</div>}
      {hasStats?(
        <div>
          <div style={{display:"flex",gap:"24px",justifyContent:"center",marginTop:"8px",marginBottom:"6px"}}>
            {ops&&<div style={{textAlign:"center"}}><div style={{fontSize:"32px",fontWeight:700,color:st?.stale?"#f59e0b":C.gold,fontFamily:"monospace"}}>{ops}</div><div style={{fontSize:"12px",color:C.textDim,letterSpacing:"2px"}}>OPS</div></div>}
            {era&&<div style={{textAlign:"center"}}><div style={{fontSize:"32px",fontWeight:700,color:st?.stale?"#f59e0b":C.teal,fontFamily:"monospace"}}>{era}</div><div style={{fontSize:"12px",color:C.textDim,letterSpacing:"2px"}}>ERA</div></div>}
          </div>
          {st?.dateStr&&<div style={{fontSize:"12px",color:st.stale?"#f59e0b":C.textDim,textAlign:"center"}}>{st.stale?"⚠ ":""}Stats as of {st.dateStr}{st.ag&&st.ag!==player.ageGroup?` (${st.ag})`:""}  </div>}
        </div>
      ):(
        <div style={{fontSize:"14px",color:C.textDim,fontStyle:"italic"}}>No stats yet</div>
      )}
    </div>
  );
}

function TeamIntroCard({team}){
  if(!team)return null;
  return(
    <div style={{background:C.surface,border:`3px solid ${C.gold}88`,borderRadius:"16px",padding:"48px 56px",textAlign:"center",minWidth:"400px",maxWidth:"600px"}}>
      <div style={{width:"100px",height:"100px",borderRadius:"50%",background:C.greenLight,border:`3px solid ${C.gold}55`,margin:"0 auto 24px",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontFamily:"'Bebas Neue',serif",fontSize:"50px",color:C.gold}}>W</span>
      </div>
      {team.ageGroup&&<div style={{display:"inline-block",background:C.gold+"22",border:`1px solid ${C.gold}55`,color:C.gold,padding:"6px 20px",borderRadius:"20px",fontSize:"20px",fontWeight:700,letterSpacing:"3px",marginBottom:"20px"}}>{team.ageGroup}</div>}
      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"52px",color:C.text,letterSpacing:"4px",lineHeight:1,marginBottom:"12px"}}>{team.teamName}</div>
      <div style={{fontSize:"20px",color:C.gold,letterSpacing:"2px",marginBottom:"8px"}}>{team.tournamentName}</div>
      {team.tournamentStartDate&&<div style={{fontSize:"15px",color:C.textDim,letterSpacing:"1px"}}>{new Date(team.tournamentStartDate+'T12:00:00').toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}{team.tournamentEndDate&&team.tournamentEndDate!==team.tournamentStartDate?` – ${new Date(team.tournamentEndDate+'T12:00:00').toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"})}`:""}</div>}
      <div style={{fontSize:"13px",color:C.textDim,marginTop:"16px",letterSpacing:"1px"}}>{(team.players||[]).length} PLAYERS</div>
    </div>
  );
}

export default function Facility(){
  const [mode,setMode]=useState('select');
  const [teamIdInput,setTeamIdInput]=useState('');
  const [tournamentIdInput,setTournamentIdInput]=useState('');
  const [rosterData,setRosterData]=useState(null);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  const [rotateIdx,setRotateIdx]=useState(0);
  const [displayMode,setDisplayMode]=useState('roster');
  // Weekend mode state
  const [weekendTeams,setWeekendTeams]=useState([]);
  const [weekendTournaments,setWeekendTournaments]=useState([]); // summary list for picker
  const [selectedWeekendTournId,setSelectedWeekendTournId]=useState(null); // null = all, string[] = subset
  const [checkedTournIds,setCheckedTournIds]=useState([]); // picker selection
  const [weekendTeamIdx,setWeekendTeamIdx]=useState(0);
  const [weekendPlayerIdx,setWeekendPlayerIdx]=useState(-1); // -1 = team intro
  // Animation
  const [animKey,setAnimKey]=useState(0);
  const [animVars,setAnimVars]=useState({dx:'0px',dy:'0px'});
  const [showAnim,setShowAnim]=useState(false);
  const svgContainerRef=useRef(null);

  // Parse URL params
  useEffect(()=>{
    const params=new URLSearchParams(window.location.search);
    const teamId=params.get('teamId');
    const tournamentId=params.get('tournamentId');
    const urlMode=params.get('mode');
    if(urlMode==='weekend'){setDisplayMode('weekend');fetchWeekend();}
    else if(teamId&&tournamentId){fetchRoster(teamId,tournamentId);}
  },[]);

  const fetchRoster=async(teamId,tournamentId)=>{
    setLoading(true);setError('');
    try{
      const res=await fetch(`/api/facility-data?teamId=${encodeURIComponent(teamId)}&tournamentId=${encodeURIComponent(tournamentId)}`);
      const data=await res.json();
      if(!res.ok){setError(data.error||`Error ${res.status}`);setLoading(false);return;}
      setRosterData(data);setMode('roster');setRotateIdx(0);
    }catch(err){setError(err.message||'Network error');}
    setLoading(false);
  };

  const fetchWeekend=async()=>{
    setLoading(true);setError('');
    try{
      const res=await fetch('/api/facility-data?mode=weekend');
      const data=await res.json();
      if(!res.ok){setError(data.error||`Error ${res.status}`);setLoading(false);return;}
      setWeekendTeams(data.weekendTeams||[]);
      const tourn=data.tournaments||[];
      setWeekendTournaments(tourn);
      setCheckedTournIds(tourn.map(t=>t.id)); // pre-select all
      setSelectedWeekendTournId(null);
      setMode('weekend-select'); // show picker first
    }catch(err){setError(err.message||'Network error');}
    setLoading(false);
  };

  const startWeekendDisplay=(tournIds)=>{
    setSelectedWeekendTournId(tournIds); // null=all, string[]=subset
    setWeekendTeamIdx(0);setWeekendPlayerIdx(-1);
    setMode('weekend');
  };

  const sortedPlayers=rosterData?[...rosterData.players].sort((a,b)=>(parseInt(a.jersey)||999)-(parseInt(b.jersey)||999)):[];
  const spotlightPlayer=sortedPlayers[rotateIdx]||null;

  // Declare before effects that reference it in dep arrays
  const activeWeekendTeams=selectedWeekendTournId===null
    ?weekendTeams
    :weekendTeams.filter(t=>selectedWeekendTournId.includes(t.tournamentId));

  // Roster auto-rotate
  useEffect(()=>{
    if(mode!=='roster'||displayMode!=='roster'||!sortedPlayers.length)return;
    const iv=setInterval(()=>{
      setRotateIdx(i=>{
        const next=(i+1)%sortedPlayers.length;
        computeAnim(next,sortedPlayers);
        return next;
      });
    },5000);
    return()=>clearInterval(iv);
  },[mode,displayMode,sortedPlayers.length]);

  // Weekend auto-cycle
  useEffect(()=>{
    if(mode!=='weekend'||!activeWeekendTeams.length)return;
    const curTeam=activeWeekendTeams[weekendTeamIdx];
    const teamPlayers=curTeam?[...(curTeam.players||[])].sort((a,b)=>(parseInt(a.jersey)||999)-(parseInt(b.jersey)||999)):[];
    const iv=setInterval(()=>{
      setWeekendPlayerIdx(pi=>{
        if(pi===-1){computeWeekendAnim(0,teamPlayers);return 0;}
        const next=pi+1;
        if(next>=teamPlayers.length){
          setWeekendTeamIdx(ti=>(ti+1)%activeWeekendTeams.length);
          return -1;
        }
        computeWeekendAnim(next,teamPlayers);
        return next;
      });
    },5000);
    return()=>clearInterval(iv);
  },[mode,weekendTeamIdx,activeWeekendTeams.length]);

  // Reset player index when team changes in weekend mode
  useEffect(()=>{setWeekendPlayerIdx(-1);},[weekendTeamIdx]);

  const computeAnim=(nextIdx,players)=>{
    if(!svgContainerRef.current)return;
    const player=players[nextIdx];if(!player)return;
    const svgEl=svgContainerRef.current.querySelector('svg');if(!svgEl)return;
    const map=buildMap(players);
    const slot=Object.entries(map).find(([,ps])=>ps.some(p=>String(p.id||p.name)===String(player.id||player.name)));
    if(!slot)return;
    const slotPos=FIELD_POS[slot[0]];
    const slotPs=slot[1];const idx=slotPs.findIndex(p=>String(p.id||p.name)===String(player.id||player.name));
    const off=stackOff(slotPs.length)[idx]||{dx:0,dy:0};
    const jerseyX=slotPos.x+off.dx,jerseyY=slotPos.y+off.dy;
    const svgRect=svgEl.getBoundingClientRect();
    const sx=svgRect.left+jerseyX*(svgRect.width/340);
    const sy=svgRect.top+jerseyY*(svgRect.height/300);
    const cardCenterX=svgRect.right+(window.innerWidth-svgRect.right)/2;
    const cardCenterY=window.innerHeight/2;
    setAnimVars({dx:`${Math.round(sx-cardCenterX)}px`,dy:`${Math.round(sy-cardCenterY)}px`});
    setAnimKey(k=>k+1);setShowAnim(true);
    setTimeout(()=>setShowAnim(false),700);
  };
  const computeWeekendAnim=(nextIdx,players)=>{computeAnim(nextIdx,players);};

  const currentWeekendTeam=activeWeekendTeams[weekendTeamIdx]||null;
  const currentWeekendPlayers=currentWeekendTeam?[...(currentWeekendTeam.players||[])].sort((a,b)=>(parseInt(a.jersey)||999)-(parseInt(b.jersey)||999)):[];
  const fmtDateRange=(startDate,endDate)=>{if(!startDate)return"";const fmt=d=>new Date(d+'T12:00:00').toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});return endDate&&endDate!==startDate?`${fmt(startDate)} – ${fmt(endDate)}`:fmt(startDate);};
  const currentWeekendPlayer=weekendPlayerIdx>=0?currentWeekendPlayers[weekendPlayerIdx]||null:null;
  const highlightId=weekendPlayerIdx>=0&&currentWeekendPlayer?(currentWeekendPlayer.id||currentWeekendPlayer.name):null;

  // WEEKEND SELECT — tournament picker
  if(mode==='weekend-select'){
    return(
      <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif"}}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;600;700&display=swap');`}</style>
        <div style={{background:C.surface,border:`1px solid ${C.greenBorder}`,borderRadius:"12px",padding:"36px",width:"460px",maxWidth:"95vw"}}>
          <div style={{textAlign:"center",marginBottom:"28px"}}>
            <img src="/warriors-logo.png" style={{height:"52px",objectFit:"contain"}} alt="" onError={e=>{e.target.style.display="none";}}/>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"22px",color:C.gold,letterSpacing:"4px",marginTop:"10px"}}>WEEKEND DISPLAY</div>
            <div style={{fontSize:"11px",color:C.textDim,letterSpacing:"2px",marginTop:"4px"}}>SELECT A TOURNAMENT TO DISPLAY</div>
          </div>

          {weekendTournaments.length===0?(
            <div style={{textAlign:"center",padding:"20px 0",color:C.textDim,fontSize:"13px"}}>No upcoming tournaments with rosters found in the next 21 days.</div>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:"10px",marginBottom:"16px"}}>
              {weekendTournaments.map(t=>{
                const checked=checkedTournIds.includes(t.id);
                return(
                  <div key={t.id} onClick={()=>setCheckedTournIds(ids=>checked?ids.filter(x=>x!==t.id):[...ids,t.id])}
                    style={{background:C.bg,border:`1px solid ${checked?C.gold:C.greenBorder}`,borderRadius:"8px",padding:"14px 16px",cursor:"pointer",textAlign:"left",transition:"border-color 0.15s",display:"flex",alignItems:"flex-start",gap:"12px"}}
                    onMouseEnter={e=>e.currentTarget.style.borderColor=C.gold}
                    onMouseLeave={e=>e.currentTarget.style.borderColor=checked?C.gold:C.greenBorder}>
                    {/* Checkbox */}
                    <div style={{width:"18px",height:"18px",borderRadius:"4px",border:`2px solid ${checked?C.gold:C.greenBorder}`,background:checked?C.gold+"33":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:"2px",transition:"all 0.15s"}}>
                      {checked&&<div style={{width:"10px",height:"10px",background:C.gold,borderRadius:"2px"}}/>}
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"20px",color:C.text,letterSpacing:"2px",marginBottom:"4px"}}>{t.name}</div>
                      {(t.startDate||t.location)&&(
                        <div style={{fontSize:"12px",color:C.textDim,marginBottom:"6px"}}>
                          {fmtDateRange(t.startDate,t.endDate)}{t.location?` · ${t.location}`:""}
                        </div>
                      )}
                      <div style={{display:"flex",gap:"12px"}}>
                        <span style={{fontSize:"11px",color:C.gold,background:C.gold+"18",border:`1px solid ${C.gold}33`,padding:"2px 10px",borderRadius:"10px",fontFamily:"monospace"}}>{t.teamCount} team{t.teamCount!==1?"s":""}</span>
                        <span style={{fontSize:"11px",color:C.teal,background:C.teal+"18",border:`1px solid ${C.teal}33`,padding:"2px 10px",borderRadius:"10px",fontFamily:"monospace"}}>{t.playerCount} players</span>
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* Action button */}
              <button
                disabled={checkedTournIds.length===0}
                onClick={()=>startWeekendDisplay(checkedTournIds.length===weekendTournaments.length?null:checkedTournIds)}
                style={{background:checkedTournIds.length>0?C.gold+"22":"transparent",border:`1px solid ${checkedTournIds.length>0?C.gold:C.greenBorder}`,borderRadius:"8px",padding:"13px 20px",cursor:checkedTournIds.length>0?"pointer":"not-allowed",color:checkedTournIds.length>0?C.gold:C.textDim,fontSize:"13px",fontFamily:"monospace",letterSpacing:"1px",fontWeight:700,textAlign:"center",opacity:checkedTournIds.length>0?1:0.4}}>
                {checkedTournIds.length===0?"SELECT A TOURNAMENT ABOVE":checkedTournIds.length===weekendTournaments.length?`🏆 DISPLAY ALL (${weekendTeams.length} teams)`:`🏆 DISPLAY SELECTED (${checkedTournIds.length} tournament${checkedTournIds.length!==1?"s":""})`}
              </button>
            </div>
          )}

          <button onClick={()=>setMode('select')} style={{width:"100%",background:"transparent",border:`1px solid ${C.greenBorder}`,color:C.textDim,padding:"10px",borderRadius:"6px",fontSize:"11px",fontFamily:"monospace",cursor:"pointer",letterSpacing:"1px"}}>← BACK</button>
        </div>
      </div>
    );
  }

  // SELECT mode
  if(mode==='select'){
    return(
      <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Inter',sans-serif"}}>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;600;700&display=swap');`}</style>
        <div style={{background:C.surface,border:`1px solid ${C.greenBorder}`,borderRadius:"10px",padding:"36px",width:"360px"}}>
          <div style={{textAlign:"center",marginBottom:"28px"}}>
            <img src="/warriors-logo.png" style={{height:"64px",objectFit:"contain"}} alt="Warrior Academy" onError={e=>{e.target.style.display="none";}}/>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"24px",color:C.gold,letterSpacing:"4px",marginTop:"12px"}}>Warrior Academy</div>
            <div style={{fontSize:"10px",color:C.textDim,letterSpacing:"3px",marginTop:"4px"}}>FACILITY DISPLAY</div>
          </div>
          {error&&<div style={{background:C.red+"22",border:`1px solid ${C.red}44`,color:C.red,padding:"8px 12px",borderRadius:"4px",fontSize:"11px",marginBottom:"16px"}}>{error}</div>}
          {/* Weekend mode button */}
          <button onClick={fetchWeekend} disabled={loading} style={{width:"100%",background:C.gold+"22",border:`1px solid ${C.gold}55`,color:C.gold,padding:"12px",borderRadius:"6px",fontSize:"13px",fontWeight:700,letterSpacing:"2px",cursor:"pointer",marginBottom:"16px",fontFamily:"'DM Mono',monospace"}}>
            {loading?"LOADING...":"🏆 WEEKEND MODE (ALL TEAMS)"}
          </button>
          <div style={{textAlign:"center",fontSize:"10px",color:C.textDim,letterSpacing:"1px",marginBottom:"16px"}}>— or select a specific roster —</div>
          <div style={{marginBottom:"12px"}}>
            <label style={{fontSize:"9px",color:C.textDim,letterSpacing:"2px",display:"block",marginBottom:"5px"}}>TEAM ID</label>
            <input value={teamIdInput} onChange={e=>setTeamIdInput(e.target.value)} placeholder="e.g. team_abc" style={{width:"100%",background:C.bg,border:`1px solid ${C.greenBorder}`,color:C.text,padding:"9px 11px",borderRadius:"4px",fontSize:"12px",fontFamily:"monospace",boxSizing:"border-box"}}/>
          </div>
          <div style={{marginBottom:"20px"}}>
            <label style={{fontSize:"9px",color:C.textDim,letterSpacing:"2px",display:"block",marginBottom:"5px"}}>TOURNAMENT ID</label>
            <input value={tournamentIdInput} onChange={e=>setTournamentIdInput(e.target.value)} placeholder="e.g. tourn_xyz" style={{width:"100%",background:C.bg,border:`1px solid ${C.greenBorder}`,color:C.text,padding:"9px 11px",borderRadius:"4px",fontSize:"12px",fontFamily:"monospace",boxSizing:"border-box"}}/>
          </div>
          <button disabled={loading||!teamIdInput||!tournamentIdInput} onClick={()=>fetchRoster(teamIdInput.trim(),tournamentIdInput.trim())} style={{width:"100%",background:C.gold,color:"#071405",border:"none",padding:"12px",borderRadius:"4px",fontSize:"13px",fontFamily:"monospace",fontWeight:700,letterSpacing:"2px",cursor:loading||!teamIdInput||!tournamentIdInput?"not-allowed":"pointer",opacity:loading||!teamIdInput||!tournamentIdInput?0.5:1}}>
            {loading?"LOADING...":"DISPLAY ROSTER"}
          </button>
        </div>
      </div>
    );
  }

  // WEEKEND MODE display
  if(mode==='weekend'){
    const diamondScale=Math.max(1.4,+(window.innerHeight*0.55/300).toFixed(2));
    return(
      <div style={{minHeight:"100vh",height:"100vh",background:"#071405",display:"flex",flexDirection:"column",fontFamily:"'Inter',sans-serif",overflow:"hidden",position:"relative"}}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;600;700&display=swap');
          @keyframes facCardAnim{from{transform:translate(var(--dx),var(--dy)) scale(0.08);opacity:0;}to{transform:translate(0,0) scale(1);opacity:1;}}
        `}</style>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 28px",borderBottom:`1px solid ${C.greenBorder}`,flexShrink:0,background:"#071405"}}>
          <div style={{display:"flex",alignItems:"center",gap:"16px"}}>
            <img src="/warriors-logo.png" style={{height:"48px",objectFit:"contain"}} alt="Warriors" onError={e=>{e.target.style.display="none";}}/>
            <div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"26px",color:C.gold,letterSpacing:"4px",lineHeight:1}}>Warrior Academy</div>
              <div style={{fontSize:"11px",color:C.textDim,letterSpacing:"2px",marginTop:"2px"}}>🏆 WEEKEND SHOWCASE</div>
            </div>
          </div>
          <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
            <div style={{display:"flex",gap:"4px",flexWrap:"wrap",maxWidth:"360px",justifyContent:"flex-end"}}>
              {activeWeekendTeams.map((t,i)=>(
                <div key={i} style={{width:"8px",height:"8px",borderRadius:"50%",background:i===weekendTeamIdx?C.gold:C.greenBorder,transition:"background 0.3s",cursor:"pointer",flexShrink:0}} onClick={()=>{setWeekendTeamIdx(i);setWeekendPlayerIdx(-1);}}/>
              ))}
            </div>
            <button onClick={()=>setMode('weekend-select')} style={{background:"transparent",border:`1px solid ${C.greenBorder}`,color:C.textDim,padding:"6px 12px",fontSize:"9px",cursor:"pointer",fontFamily:"monospace",borderRadius:"3px",marginLeft:"8px"}}>← BACK</button>
          </div>
        </div>
        {/* Main content */}
        <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:"40px",padding:"20px 36px",overflow:"hidden",minHeight:0}} ref={svgContainerRef}>
          {/* Diamond + team label */}
          <div style={{flexShrink:0,display:"flex",flexDirection:"column",alignItems:"center",gap:"10px"}}>
            {currentWeekendTeam&&weekendPlayerIdx>=0&&(
              <div style={{textAlign:"center"}}>
                {currentWeekendTeam.ageGroup&&<div style={{fontSize:"11px",color:C.gold,letterSpacing:"3px",fontFamily:"'DM Mono',monospace",marginBottom:"2px"}}>{currentWeekendTeam.ageGroup}</div>}
                <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"20px",color:C.text,letterSpacing:"2px",lineHeight:1}}>{currentWeekendTeam.teamName}</div>
                <div style={{fontSize:"11px",color:C.textDim,letterSpacing:"1px",marginTop:"2px"}}>{currentWeekendTeam.tournamentName}</div>
              </div>
            )}
            <FacilityDiamond players={currentWeekendPlayers} highlightId={highlightId} scale={diamondScale}/>
          </div>
          {/* Spotlight */}
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"16px",minHeight:0}}>
            {weekendPlayerIdx===-1?(
              <TeamIntroCard team={currentWeekendTeam}/>
            ):(
              <PlayerSpotlight player={currentWeekendPlayer} animKey={animKey} animVars={animVars} showAnim={showAnim}/>
            )}
          </div>
        </div>
        {/* Watermark */}
        <div style={{position:"fixed",bottom:"16px",right:"20px",opacity:0.12,pointerEvents:"none"}}>
          <img src="/warriors-logo.png" style={{height:"80px",objectFit:"contain"}} alt="" onError={e=>{e.target.style.display="none";}}/>
        </div>
      </div>
    );
  }

  // ROSTER / STATS display mode
  const diamondScale=Math.max(1.4,+(window.innerHeight*0.55/300).toFixed(2));
  return(
    <div style={{minHeight:"100vh",height:"100vh",background:"#071405",display:"flex",flexDirection:"column",fontFamily:"'Inter',sans-serif",overflow:"hidden",position:"relative"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;600;700&display=swap');
        @keyframes facCardAnim{from{transform:translate(var(--dx),var(--dy)) scale(0.08);opacity:0;}to{transform:translate(0,0) scale(1);opacity:1;}}
      `}</style>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 24px",background:"#071405",borderBottom:`1px solid ${C.greenBorder}`,flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:"16px"}}>
          <img src="/warriors-logo.png" style={{height:"48px",objectFit:"contain"}} alt="Warriors" onError={e=>{e.target.style.display="none";}}/>
          <div>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"26px",color:C.gold,letterSpacing:"4px",lineHeight:1}}>{rosterData?.teamName||"Warrior Academy"}</div>
            {rosterData?.tournamentName&&<div style={{fontSize:"12px",color:C.textDim,letterSpacing:"2px",marginTop:"2px"}}>{rosterData.tournamentName}</div>}
          </div>
        </div>
        <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
          <button onClick={()=>setDisplayMode('roster')} style={{background:displayMode==='roster'?C.gold+"22":"transparent",border:`1px solid ${displayMode==='roster'?C.gold:C.greenBorder}`,color:displayMode==='roster'?C.gold:C.textDim,padding:"5px 12px",fontSize:"9px",cursor:"pointer",fontFamily:"monospace",borderRadius:"3px",letterSpacing:"1px"}}>◆ ROSTER</button>
          <button onClick={()=>setMode('select')} style={{background:"transparent",border:`1px solid ${C.greenBorder}`,color:C.textDim,padding:"5px 12px",fontSize:"9px",cursor:"pointer",fontFamily:"monospace",borderRadius:"3px",marginLeft:"4px"}}>← BACK</button>
        </div>
      </div>
      {/* Roster display */}
      {displayMode==='roster'&&(
        <div ref={svgContainerRef} style={{flex:1,display:"flex",alignItems:"center",gap:"40px",padding:"20px 40px",overflow:"hidden",minHeight:0}}>
          <div style={{flexShrink:0,display:"flex",flexDirection:"column",alignItems:"center",gap:"10px"}}>
            {rosterData&&(
              <div style={{textAlign:"center"}}>
                {rosterData.ageGroup&&<div style={{fontSize:"11px",color:C.gold,letterSpacing:"3px",fontFamily:"'DM Mono',monospace",marginBottom:"2px"}}>{rosterData.ageGroup}</div>}
                <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:"20px",color:C.text,letterSpacing:"2px",lineHeight:1}}>{rosterData.teamName}</div>
                <div style={{fontSize:"11px",color:C.textDim,letterSpacing:"1px",marginTop:"2px"}}>{rosterData.tournamentName}</div>
              </div>
            )}
            <FacilityDiamond players={sortedPlayers} highlightId={spotlightPlayer?.id||spotlightPlayer?.name||null} scale={diamondScale}/>
          </div>
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"16px",minHeight:0}}>
            <PlayerSpotlight player={spotlightPlayer} animKey={animKey} animVars={animVars} showAnim={showAnim}/>
            {sortedPlayers.length>0&&(
              <div style={{display:"flex",gap:"5px",flexWrap:"wrap",justifyContent:"center",maxWidth:"400px"}}>
                {sortedPlayers.map((p,i)=>(
                  <div key={p.name+i} onClick={()=>{setRotateIdx(i);computeAnim(i,sortedPlayers);}} style={{width:i===rotateIdx?"14px":"7px",height:"7px",borderRadius:"4px",background:i===rotateIdx?C.gold:C.greenBorder,transition:"all 0.3s",cursor:"pointer"}}/>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      {/* Watermark */}
      <div style={{position:"fixed",bottom:"16px",right:"20px",opacity:0.12,pointerEvents:"none"}}>
        <img src="/warriors-logo.png" style={{height:"80px",objectFit:"contain"}} alt="" onError={e=>{e.target.style.display="none";}}/>
      </div>
    </div>
  );
}
